import { Skeleton } from '@mui/material'
import { Tabs } from 'components/core-v2'
import { format } from 'date-fns'
import { useState } from 'react'

import classes from './deductions-tab.module.scss'
import { FeeBreakdownLoadingTable, FeeBreakdownTable } from './fee-breakdown-table'
import { FormattedFeeDataWithDate } from './utils'

interface Props {
  data: FormattedFeeDataWithDate[]
}
export const DeductionsTab = ({ data }: Props) => {
  const [selectedDate, setSelectedDate] = useState(data?.[0]?.date)

  if (!selectedDate)
    return <div className={classes.noRows}>There are no fee deductions for this period</div>

  const selectedDateDeductions = data.find(deduction => deduction.date === selectedDate)

  return (
    <Tabs.Panel value="deductions">
      <div className={classes.root}>
        <ul role="tablist">
          {data.map(deduction => (
            <li
              key={deduction.date}
              aria-controls={`${deduction.date}-panel`}
              aria-selected={selectedDate === deduction.date}
              id={`${deduction.date}-tab`}
              role="tab"
            >
              <button type="button" onClick={() => setSelectedDate(deduction.date)}>
                {format(new Date(deduction.date), 'dd/MM/yyyy')}
              </button>
            </li>
          ))}
        </ul>
        <div
          aria-labelledby={`${selectedDateDeductions.date}-tab`}
          className={classes.table}
          id={`${selectedDateDeductions.date}-panel`}
          role="tabpanel"
        >
          <FeeBreakdownTable data={selectedDateDeductions} />
        </div>
      </div>
    </Tabs.Panel>
  )
}

export const DeductionsTabLoading = () => (
  <Tabs.Panel value="deductions">
    <div className={classes.root}>
      <ul>
        {new Array(8).fill(null).map((x, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`date-${index}`} className="mb-half">
            <Skeleton height="45px" width="100%" />
          </li>
        ))}
      </ul>
      <div className={classes.table}>
        <FeeBreakdownLoadingTable />
      </div>
    </div>
  </Tabs.Panel>
)
